module.exports = __webpack_public_path__ + "static/media/DirectorNicole.4548fd70.jpeg";